const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'path',
  tiles: {
    bridge_ew: 0,
    bridge_ew_brkn: 1,
    bridge_hanging: 2,
    bridge_ns: 3,
    bridge_ns_brkn: 4,
    ceiling1: 5,
    ceiling2: 6,
    ceiling3: 7,
    ceiling4: 8,
    door: 9,
    door_locked: 10,
    door_open: 11,
    door_unlocked: 12,
    exit_locked: 13,
    exit_locked1: 14,
    exit_locked2: 15,
    exit_locked3: 16,
    exit_wall: 17,
    exit1: 18,
    exit2: 19,
    exit3: 20,
    floor: 21,
    floor1: 22,
    floor2: 23,
    floor3: 24,
    floor4: 25,
    grate: 26,
    pedastal_empty: 27,
    pedastal_full1: 28,
    pedastal_full2: 29,
    pedastal_full3: 30,
    pedastal_full4: 31,
    pedastal_full5: 32,
    pedastal_full6: 33,
    pedastal_full7: 34,
    pedastal_full8: 35,
    stairs_down: 36,
    stairs_up: 37,
    underdoor: 38,
    underfloor: 39,
    underfloor2: 40,
    undersecret: 41,
    understairs: 42,
    underwall: 43,
    underwall2: 44,
    wall: 45,
    wall_fade1: 46,
    wall_fade2: 47,
    wall_pit: 48,
    wall1: 49,
    wall2: 50,
    wall3: 51,
    wall4: 52
  },
  uidata: {
    rects: [
      vec4(8/1024,8/256,40/1024,40/256),
      vec4(56/1024,8/256,88/1024,40/256),
      vec4(104/1024,8/256,136/1024,40/256),
      vec4(152/1024,8/256,184/1024,40/256),
      vec4(200/1024,8/256,232/1024,40/256),
      vec4(248/1024,8/256,280/1024,40/256),
      vec4(296/1024,8/256,328/1024,40/256),
      vec4(344/1024,8/256,376/1024,40/256),
      vec4(392/1024,8/256,424/1024,40/256),
      vec4(440/1024,8/256,472/1024,40/256),
      vec4(488/1024,8/256,520/1024,40/256),
      vec4(536/1024,8/256,568/1024,40/256),
      vec4(584/1024,8/256,616/1024,40/256),
      vec4(632/1024,8/256,664/1024,40/256),
      vec4(680/1024,8/256,712/1024,40/256),
      vec4(728/1024,8/256,760/1024,40/256),
      vec4(776/1024,8/256,808/1024,40/256),
      vec4(824/1024,8/256,856/1024,40/256),
      vec4(872/1024,8/256,904/1024,40/256),
      vec4(920/1024,8/256,952/1024,40/256),
      vec4(968/1024,8/256,1000/1024,40/256),
      vec4(8/1024,56/256,40/1024,88/256),
      vec4(56/1024,56/256,88/1024,88/256),
      vec4(104/1024,56/256,136/1024,88/256),
      vec4(152/1024,56/256,184/1024,88/256),
      vec4(200/1024,56/256,232/1024,88/256),
      vec4(248/1024,56/256,280/1024,88/256),
      vec4(296/1024,56/256,328/1024,88/256),
      vec4(344/1024,56/256,376/1024,88/256),
      vec4(392/1024,56/256,424/1024,88/256),
      vec4(440/1024,56/256,472/1024,88/256),
      vec4(488/1024,56/256,520/1024,88/256),
      vec4(536/1024,56/256,568/1024,88/256),
      vec4(584/1024,56/256,616/1024,88/256),
      vec4(632/1024,56/256,664/1024,88/256),
      vec4(680/1024,56/256,712/1024,88/256),
      vec4(728/1024,56/256,760/1024,88/256),
      vec4(776/1024,56/256,808/1024,88/256),
      vec4(824/1024,56/256,856/1024,88/256),
      vec4(872/1024,56/256,904/1024,88/256),
      vec4(920/1024,56/256,952/1024,88/256),
      vec4(968/1024,56/256,1000/1024,88/256),
      vec4(8/1024,104/256,40/1024,136/256),
      vec4(56/1024,104/256,88/1024,136/256),
      vec4(104/1024,104/256,136/1024,136/256),
      vec4(152/1024,104/256,184/1024,136/256),
      vec4(200/1024,104/256,232/1024,136/256),
      vec4(248/1024,104/256,280/1024,136/256),
      vec4(296/1024,104/256,328/1024,136/256),
      vec4(344/1024,104/256,376/1024,136/256),
      vec4(392/1024,104/256,424/1024,136/256),
      vec4(440/1024,104/256,472/1024,136/256),
      vec4(488/1024,104/256,520/1024,136/256)
    ]
  },
  layers: undefined,
  FRAME_BRIDGE_EW: 0,
  FRAME_BRIDGE_EW_BRKN: 1,
  FRAME_BRIDGE_HANGING: 2,
  FRAME_BRIDGE_NS: 3,
  FRAME_BRIDGE_NS_BRKN: 4,
  FRAME_CEILING1: 5,
  FRAME_CEILING2: 6,
  FRAME_CEILING3: 7,
  FRAME_CEILING4: 8,
  FRAME_DOOR: 9,
  FRAME_DOOR_LOCKED: 10,
  FRAME_DOOR_OPEN: 11,
  FRAME_DOOR_UNLOCKED: 12,
  FRAME_EXIT_LOCKED: 13,
  FRAME_EXIT_LOCKED1: 14,
  FRAME_EXIT_LOCKED2: 15,
  FRAME_EXIT_LOCKED3: 16,
  FRAME_EXIT_WALL: 17,
  FRAME_EXIT1: 18,
  FRAME_EXIT2: 19,
  FRAME_EXIT3: 20,
  FRAME_FLOOR: 21,
  FRAME_FLOOR1: 22,
  FRAME_FLOOR2: 23,
  FRAME_FLOOR3: 24,
  FRAME_FLOOR4: 25,
  FRAME_GRATE: 26,
  FRAME_PEDASTAL_EMPTY: 27,
  FRAME_PEDASTAL_FULL1: 28,
  FRAME_PEDASTAL_FULL2: 29,
  FRAME_PEDASTAL_FULL3: 30,
  FRAME_PEDASTAL_FULL4: 31,
  FRAME_PEDASTAL_FULL5: 32,
  FRAME_PEDASTAL_FULL6: 33,
  FRAME_PEDASTAL_FULL7: 34,
  FRAME_PEDASTAL_FULL8: 35,
  FRAME_STAIRS_DOWN: 36,
  FRAME_STAIRS_UP: 37,
  FRAME_UNDERDOOR: 38,
  FRAME_UNDERFLOOR: 39,
  FRAME_UNDERFLOOR2: 40,
  FRAME_UNDERSECRET: 41,
  FRAME_UNDERSTAIRS: 42,
  FRAME_UNDERWALL: 43,
  FRAME_UNDERWALL2: 44,
  FRAME_WALL: 45,
  FRAME_WALL_FADE1: 46,
  FRAME_WALL_FADE2: 47,
  FRAME_WALL_PIT: 48,
  FRAME_WALL1: 49,
  FRAME_WALL2: 50,
  FRAME_WALL3: 51,
  FRAME_WALL4: 52
};
spritesheetRegister(module.exports);
